/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  block: Boolean,
  content: {
    type: [String, Function]
  },
  "default": {
    type: [String, Function]
  },
  disabled: Boolean,
  ghost: Boolean,
  href: {
    type: String,
    "default": ""
  },
  icon: {
    type: Function
  },
  loading: Boolean,
  shape: {
    type: String,
    "default": "rectangle",
    validator: function validator(val) {
      if (!val) return true;
      return ["rectangle", "square", "round", "circle"].includes(val);
    }
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  suffix: {
    type: Function
  },
  tag: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["button", "a", "div"].includes(val);
    }
  },
  theme: {
    type: String,
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "primary", "danger", "warning", "success"].includes(val);
    }
  },
  type: {
    type: String,
    "default": "button",
    validator: function validator(val) {
      if (!val) return true;
      return ["submit", "reset", "button"].includes(val);
    }
  },
  variant: {
    type: String,
    "default": "base",
    validator: function validator(val) {
      if (!val) return true;
      return ["base", "outline", "dashed", "text"].includes(val);
    }
  },
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/button/props.js
// module id = null
// module chunks = 